import React from 'react';
import { Row, Section, Toggle } from '../settingsPrimitives';
import { usePreferencesStore } from '../../store/preferencesStore';

/**
 * Settings › Privacy & Data › Usage data (owner, 16.10.2026). The same
 * question as the one-time card after sign-in (UsageConsentCard), standing:
 * only which features, linked to the account, updated about twice a day.
 * Switching it either way counts as an answer, so the card never comes back.
 */
const UsageDataSection = ({ t }) => {
  const sendUsageData = usePreferencesStore((s) => s.sendUsageData);
  const answer = usePreferencesStore((s) => s.answerUsageConsent);
  return (
    <Section title={t('settings.usageDataSection')}>
      <Row label={t('settings.sendUsageData')} desc={t('settings.sendUsageDataDesc')}>
        <Toggle value={sendUsageData === true} onChange={(v) => answer(v)} label={t('settings.sendUsageData')} />
      </Row>
    </Section>
  );
};

export default UsageDataSection;
